// @ts-nocheck
/* eslint-disable */
/* tslint:disable */
/* prettier-ignore-start */
/** @jsxRuntime classic */
/** @jsx createPlasmicElementProxy */
/** @jsxFrag React.Fragment */
// This class is auto-generated by Plasmic; please do not edit!
// Plasmic Project: gZEhwnQAfx2q6zBpBNhhDQ
// Component: oup6gZYMcw6R
import * as React from "react";
import {
  classNames,
  createPlasmicElementProxy,
  deriveRenderOpts
} from "@plasmicapp/react-web";
import { useDataEnv } from "@plasmicapp/react-web/lib/host";
import "@plasmicapp/react-web/lib/plasmic.css";
import plasmic_antd_5_hostless_css from "../antd_5_hostless/plasmic_antd_5_hostless.module.css"; // plasmic-import: ohDidvG9XsCeFumugENU3J/projectcss
import projectcss from "./plasmic_collect_wise_draft.module.css"; // plasmic-import: gZEhwnQAfx2q6zBpBNhhDQ/projectcss
import sty from "./PlasmicMilestoneHeader.module.css"; // plasmic-import: oup6gZYMcw6R/css

createPlasmicElementProxy;

export const PlasmicMilestoneHeader__VariantProps = new Array();

export const PlasmicMilestoneHeader__ArgProps = new Array();

const $$ = {};

function PlasmicMilestoneHeader__RenderFunc(props) {
  const { variants, overrides, forNode } = props;
  const args = React.useMemo(
    () =>
      Object.assign(
        {},
        Object.fromEntries(
          Object.entries(props.args).filter(([_, v]) => v !== undefined)
        )
      ),
    [props.args]
  );
  const $props = {
    ...args,
    ...variants
  };
  const $ctx = useDataEnv?.() || {};
  const refsRef = React.useRef({});
  const $refs = refsRef.current;
  return (
    <div
      data-plasmic-name={"root"}
      data-plasmic-override={overrides.root}
      data-plasmic-root={true}
      data-plasmic-for-node={forNode}
      className={classNames(
        projectcss.all,
        projectcss.root_reset,
        projectcss.plasmic_default_styles,
        projectcss.plasmic_mixins,
        projectcss.plasmic_tokens,
        plasmic_antd_5_hostless_css.plasmic_tokens,
        sty.root
      )}
    >
      <div
        data-plasmic-name={"text"}
        data-plasmic-override={overrides.text}
        className={classNames(projectcss.all, projectcss.__wab_text, sty.text)}
      >
        {"Add Milestone"}
      </div>
      <div
        data-plasmic-name={"closeButton"}
        data-plasmic-override={overrides.closeButton}
        className={classNames(
          projectcss.all,
          projectcss.__wab_text,
          sty.closeButton
        )}
      >
        {"X"}
      </div>
    </div>
  );
}

const PlasmicDescendants = {
  root: ["root", "text", "closeButton"],
  text: ["text"],
  closeButton: ["closeButton"]
};

function makeNodeComponent(nodeName) {
  const func = function (props) {
    const { variants, args, overrides } = React.useMemo(
      () =>
        deriveRenderOpts(props, {
          name: nodeName,
          descendantNames: PlasmicDescendants[nodeName],
          internalArgPropNames: PlasmicMilestoneHeader__ArgProps,
          internalVariantPropNames: PlasmicMilestoneHeader__VariantProps
        }),
      [props, nodeName]
    );
    return PlasmicMilestoneHeader__RenderFunc({
      variants,
      args,
      overrides,
      forNode: nodeName
    });
  };
  if (nodeName === "root") {
    func.displayName = "PlasmicMilestoneHeader";
  } else {
    func.displayName = `PlasmicMilestoneHeader.${nodeName}`;
  }
  return func;
}

export const PlasmicMilestoneHeader = Object.assign(
  // Top-level PlasmicMilestoneHeader renders the root element
  makeNodeComponent("root"),
  {
    // Helper components rendering sub-elements
    text: makeNodeComponent("text"),
    closeButton: makeNodeComponent("closeButton"),
    // Metadata about props expected for PlasmicMilestoneHeader
    internalVariantProps: PlasmicMilestoneHeader__VariantProps,
    internalArgProps: PlasmicMilestoneHeader__ArgProps
  }
);

export default PlasmicMilestoneHeader;
/* prettier-ignore-end */
